@if (!isLoaded) {
  <busy-indicator big="true"></busy-indicator>
}

@if (isLoaded) {
  <form [formGroup]="tableFormGroup">
    <table mat-table fxFill [dataSource]="tableData" formArrayName="rows">
      <ng-container matColumnDef="Selected">
        <th mat-header-cell *matHeaderCellDef fxLayoutAlign="start center">
          <ng-container formGroupName="0">
            <lgd-checkbox controlName="selectAll" [toolTip]="selectTitle">
            </lgd-checkbox>
          </ng-container>
        </th>
        <td mat-cell *matCellDef="let row; let i = index">
          <div [formGroupName]="i+1">
            <lgd-checkbox controlName="selected">
            </lgd-checkbox>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="RequisitionNumber">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container formGroupName="0">
            <lgd-text controlName="requisitionNumberFilter" label="Requisition Number">
            </lgd-text>
          </ng-container>
        </th>
        <td mat-cell *matCellDef="let row">{{row.Number}}</td>
      </ng-container>
      <ng-container matColumnDef="Date">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container formGroupName="0">
            <lgd-text controlName="dateFilter" label="Date">
            </lgd-text>
          </ng-container>
        </th>
        <td mat-cell *matCellDef="let row">{{row.IssueDate | date : 'M/d/yyyy'}}</td>
      </ng-container>
      <ng-container matColumnDef="Vendor">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container formGroupName="0">
            <lgd-text controlName="vendorFilter" label="Vendor">
            </lgd-text>
          </ng-container>
        </th>
        <td mat-cell *matCellDef="let row">
          <truncate-text [mainText]="row.VendorName">
          </truncate-text>
        </td>
      </ng-container>
      <ng-container matColumnDef="Description">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container formGroupName="0">
            <lgd-text controlName="descriptionFilter" label="Description">
            </lgd-text>
          </ng-container>
        </th>
        <td mat-cell *matCellDef="let row">
          <truncate-text [mainText]="row.Description">
          </truncate-text>
        </td>
      </ng-container>
      <ng-container matColumnDef="Amount">
        <th mat-header-cell *matHeaderCellDef>
          <ng-container formGroupName="0">
            <lgd-text controlName="amountFilter" label="Amount">
            </lgd-text>
          </ng-container>
        </th>
        <td mat-cell *matCellDef="let row">{{row.TotalAmount | currency}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
      <tr mat-row *matRowDef="let myRowData; columns: columnNames"></tr>
    </table>
    @if (!hasData) {
      <div fxLayout="row" fxLayoutAlign="center start">
        <b>{{message}}</b>
      </div>
    }
  </form>
  <div [formGroup]="issueDateGroup" style="margin: 10px 0;">
    <div fxLayout="row" fxLayoutAlign="space-between" style="font-weight:bold;">
      <span>Purchase Order Date</span>
      <span style="margin-right: 5.8%">GRAND TOTAL: {{GrandTotal | currency}}</span>
    </div>
    <lgd-date-picker controlName="issueDate" label="Issue Date" telemetry="Edit-IssueDate-RequisitionSelectionReview-Purchasing">
    </lgd-date-picker>
    <lgd-checkbox controlName="useRequisitionDate" label="Use Requisition Issue Date" aria-label="Select-RequisitionDate-IssueDate-RequisitionSelectionReview-Purchasing">
    </lgd-checkbox>
  </div>
  <div fxFill fxLayoutAlign="end start">
    Review Selected ({{selected}})
  </div>
}
